export default "__VITE_ASSET__rP1l$xhK__"